import { Button } from "devextreme-react/button";
import React from "react";
import PropTypes from "prop-types";
import ScrollView from "devextreme-react/scroll-view";
import {
  envIconDataReceiptSvg,
  copyIconDataReceiptSvg,
} from "../../Assets/SVGs/dataReceiptSVGs";
import { Status } from "../../Constants/constants";
import "./EnvDetails.scss";

const DataReceiptEnvDetail = ({
  envDataName,
  envDataAccessUrl,
  envDataActive,
  envDataCreatedOn,
  envDataLastUpdatedOn,
  supportedFileTypes = "",
  envDataAppRegistrationId,
  copyToClipboard,
}) => (
  <div>
    <span>{envIconDataReceiptSvg}</span>
    <br />
    <span className="env-Name"> {envDataName}</span>
    <br />
    <ScrollView className="env-Info-scroll" direction="vertical">
      <span className="env-Info-URL">
        URL:&nbsp; <span className="env_Url">{envDataAccessUrl}</span>
      </span>
      <br />
      <span className="env-Info">
        Status:&nbsp;{" "}
        <span
          className={envDataActive === true ? "env_Status_Active" : "env_Status_InActive"}
        >
          {envDataActive === true ? Status?.ACTIVE : Status?.IN_ACTIVE}
        </span>
      </span>
      <br />
      <span className="env-Info">
        Created on:&nbsp;{" "}
        <span className="env_Created">
          {envDataCreatedOn?.substring(8, 10)}&nbsp;
          {new Date(envDataCreatedOn?.substring(5, 7))?.toLocaleString("en-us", {
            month: "short",
          })}
          &nbsp;
          {envDataCreatedOn?.substring(0, 4)}&nbsp;
        </span>
      </span>
      <br />
      <span className="env-Info">
        Updated on:&nbsp;{" "}
        <span className="env_Updated">
          {envDataLastUpdatedOn?.substring(8, 10)}&nbsp;
          {new Date(envDataLastUpdatedOn?.substring(5, 7)).toLocaleString("en-us", {
            month: "short",
          })}
          &nbsp;
          {envDataLastUpdatedOn?.substring(0, 4)}&nbsp;
        </span>
      </span>
      <br />
      <div>
        <span className="env-Info-clientID">
          Client ID:
          <div className="env_ClientID">
            {envDataAppRegistrationId?.substring(0, 12)}...
            <span className="tooltiptext">{envDataAppRegistrationId}</span>
          </div>
          <span className="copy_ClientID">
            &nbsp;
            <Button onClick={copyToClipboard}>{copyIconDataReceiptSvg}</Button>
          </span>
        </span>
      </div>
      <div className="env-Info">
        Acceptable file types:
        <div className="filetypes-data env-supportedFileTypes">
          {supportedFileTypes.split(",").map((fileType) => (
            <div key={fileType}>{fileType.trim()}</div>
          ))}
        </div>
      </div>
    </ScrollView>
  </div>
);
DataReceiptEnvDetail.propTypes = {
  copyToClipboard: PropTypes.func.isRequired,
  envDataAccessUrl: PropTypes.string.isRequired,
  envDataActive: PropTypes.bool.isRequired,
  envDataAppRegistrationId: PropTypes.string.isRequired,
  envDataCreatedOn: PropTypes.string.isRequired,
  envDataLastUpdatedOn: PropTypes.string.isRequired,
  envDataName: PropTypes.string.isRequired,
  supportedFileTypes: PropTypes.string,
};
export default DataReceiptEnvDetail;
